var symphony = symphony || {};

;
(function () {

    symphony.initCarouselCount = 0;
    symphony.initCarousel = function ($container) {

        if (symphony.initCarouselCount < 5) {
            // remove existing carousels first
            var $existingCarousels = $container ? $container.find(".amazingcarousel-container") : $(".amazingcarousel-container");
            $existingCarousels.remove();

            var $dnCarousel = $container ? $container.find('div[data-name="dn-carousel"]') : $('div[data-name="dn-carousel"]');

            if ($dnCarousel.length > 0) {
                $dnCarousel.each(function (i, dnCarouselElm) {
                    var carouselItems = [];
                    $(dnCarouselElm).find("div").each(function (ii, child) {
                        if (child.dataset && child.dataset.thumbnail && child.dataset.thumbnail.length > 0 && child.dataset.lightbox && child.dataset.lightbox.length > 0) {
                            carouselItems.push({
                                thumbnail: child.dataset.thumbnail,
                                lightbox: child.dataset.lightbox,
                                title: child.dataset.title || ""
                            });
                        }
                    });
                    $(dnCarouselElm).after(symphony.templates["amazing-carousel"]({
                        carouselIndex: i,
                        items: carouselItems
                    }));
                });

                var $carousel = $container ? $container.find(".amazingcarousel") : $(".amazingcarousel");
                var $lightbox = $container ? $container.find(".html5lightbox") : $(".html5lightbox");
                if ($carousel.length > 0) {
                    var jsFolder = "//static.salvationarmy.org/us-east-1/templates/symphony/static_resources/vendors/amazing-carousel/";

                    if (typeof html5Lightbox === "undefined" && $lightbox.length > 0) {
                        html5Lightbox = $lightbox.html5lightbox({
                            skinsfoldername: "",
                            jsfolder: jsFolder,
                            barheight: 64,
                            showtitle: true,
                            showdescription: false,
                            shownavigation: false,
                            thumbwidth: 80,
                            thumbheight: 60,
                            thumbtopmargin: 12,
                            thumbbottommargin: 8,
                            titlebottomcss: '{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}',
                            descriptionbottomcss: '{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}'
                        });
                    }

                    $carousel.each(function () {
                        $(this).amazingcarousel({
                            jsfolder: jsFolder,
                            width: 320,
                            height: 180,
                            skinsfoldername: "",
                            interval: 3000,
                            itembottomshadowimagetop: 0,
                            donotcrop: false,
                            random: false,
                            showhoveroverlay: true,
                            rownumber: 1,
                            height: 180,
                            arrowheight: 48,
                            showbottomshadow: false,
                            itembackgroundimagewidth: 0,
                            imageheight: 180,
                            skin: "Simplicity",
                            responsive: true,
                            lightboxtitlebottomcss: "{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
                            enabletouchswipe: true,
                            navstyle: "none",
                            backgroundimagetop: 0,
                            arrowstyle: "always",
                            bottomshadowimagetop: 0,
                            hidehoveroverlayontouch: false,
                            continuous: false,
                            itembackgroundimagetop: 0,
                            hoveroverlayimage: "hoveroverlay-64-64-4.png",
                            itembottomshadowimage: "itembottomshadow-100-100-5.png",
                            lightboxshowdescription: false,
                            width: 320,
                            navswitchonmouseover: false,
                            showhoveroverlayalways: false,
                            transitioneasing: "easeOutExpo",
                            lightboxshownavigation: false,
                            showitembackgroundimage: false,
                            itembackgroundimage: "",
                            playvideoimagepos: "center",
                            circular: true,
                            arrowimage: "arrows-48-48-3.png",
                            scrollitems: 1,
                            direction: "horizontal",
                            lightboxdescriptionbottomcss: "{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
                            supportiframe: false,
                            navimage: "bullet-16-16-0.png",
                            backgroundimagewidth: 0,
                            showbackgroundimage: false,
                            lightboxbarheight: 64,
                            showplayvideo: true,
                            spacing: 4,
                            lightboxthumbwidth: 80,
                            navdirection: "horizontal",
                            itembottomshadowimagewidth: 0,
                            backgroundimage: "",
                            lightboxthumbtopmargin: 12,
                            autoplay: true,
                            lightboxnogroup: false,
                            arrowwidth: 48,
                            transparent: false,
                            continuousduration: 2500,
                            bottomshadowimage: "bottomshadow-110-95-0.png",
                            scrollmode: "page",
                            navmode: "page",
                            lightboxshowtitle: true,
                            lightboxthumbbottommargin: 8,
                            arrowhideonmouseleave: 1000,
                            showitembottomshadow: false,
                            lightboxthumbheight: 60,
                            navspacing: 8,
                            pauseonmouseover: true,
                            imagefillcolor: "FFFFFF",
                            playvideoimage: "playvideo-64-64-0.png",
                            transitionduration: 1000,
                            visibleitems: 3,
                            imagewidth: 320,
                            usescreenquery: false,
                            bottomshadowimagewidth: 0,
                            screenquery: {
                                tablet: {
                                    screenwidth: 900,
                                    visibleitems: 2
                                },
                                mobile: {
                                    screenwidth: 600,
                                    visibleitems: 1
                                }
                            },
                            navwidth: 16,
                            loop: 0,
                            navheight: 16
                        });
                    });
                } else {
                    symphony.restartInit($container);
                }
            } else {
                symphony.restartInit($container);
            }
        }
    };

    symphony.restartInit = function ($container) {
        setTimeout(function () {
            symphony.initCarouselCount++;
            symphony.initCarousel($container);
        }, 1000);
    };


})();
